import { useContext, useState } from "react";
import clsx from "clsx";
import Markdown from "react-markdown";
import { usePage } from "@tree-company/tree-query";
import { LocaleContext } from "../app";
import { Button } from "./button";
import {
  isCompleted,
  isSessionStarted,
  markSessionStarted,
} from "../completion";
import { usePageEffects } from "../hooks/use_page_effects";

export function IntroPage({ className, page, handleSave, children }) {
  const { translate } = useContext(LocaleContext);
  const { title, htmlAttributes, key } = usePage(page);
  usePageEffects({ key });
  const [blocked] = useState(() => isCompleted() && !isSessionStarted());

  const handleSubmit = (e) => {
    markSessionStarted();
    handleSave(e);
  };

  return (
    <form
      className={clsx(className, "page", "page--intro", htmlAttributes.class)}
      onSubmit={handleSubmit}
    >
      <div className="intro__hero">
        <div className="intro__hero-content">
          {title && <h1 className="intro__hero-title">{title}</h1>}
          <p className="intro__hero-subtitle">{translate("intro.subtitle")}</p>
        </div>
      </div>
      <div className="intro__main">
        {children}
        {blocked ? (
          <p className="intro__blocked">{translate("intro.blocked")}</p>
        ) : (
          <Button
            type="submit"
            variation="filled"
            className="page__action page__action--start"
            iconNext
          >
            {translate("intro.start")}
          </Button>
        )}
      </div>
    </form>
  );
}

export function Intro({ className }) {
  const { translate } = useContext(LocaleContext);
  return (
    <div className={clsx(className, "intro__body")}>
      <Markdown>{translate("intro.body")}</Markdown>
    </div>
  );
}
